import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import style from './index.module.scss'

const FooterSection = ({ children, className }) => (
  <div className={classNames(style.FooterSection, className)}>{children}</div>
)

FooterSection.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

export default FooterSection
